<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <video width="100%" height="100%" style="margin-top: 30px;" crossorigin="anonymous" autoplay preload="auto" id="palletvideoid" loop playsinline webkit-playsinline="true" :src='path'></video>
  </div>
</template>
<script>
import LayoutHeader from './pallet-header'

export default {
  name: 'PalletIndex',
  components:{
    LayoutHeader
  },
  data () {
    return {
      path:process.env.RECORD=='production'?location.protocol+'//'+window.location.host+'/media/2021523tp.m4v':require('../../assets/2021523tp.m4v')
    }
  },
  mounted(){
    setTimeout(function () {
      const vo=document.getElementById('palletvideoid')
      vo.play()
    },500)
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}


</style>



// WEBPACK FOOTER //
// src/views/pallet/pallet-about.vue